<section class="sales-dialog"
         *ngIf="matricula.candidato.email && matricula.candidato.telefone; else noMailPhone;">
  <div mat-dialog-title>
    <h1 fxFlexAlign="start">Venda</h1>
    <div class="box"
         fxLayout="column"
         fxLayoutAlign="start start">

      <span class="box-text">Candidato</span>
      <span>{{matricula.candidato.nome}}</span>
    </div>
  </div>

  <mat-dialog-content fxLayout="column"
                      fxLayoutAlign="start start">
    <form [formGroup]="productsForm"
          fxLayout="row layout-wrap"
          fxLayoutAlign="start start"
          class="w-100">

      <table mat-table
             fxFlex="100%"
             class="sales-dialog__table"
             matTableResponsive
             #tableExpanded
             [dataSource]="dataSourceProducts">

        <ng-container matColumnDef="descricao">
          <th mat-header-cell
              *matHeaderCellDef> PRODUTO </th>
          <td mat-cell
              *matCellDef="let element"> {{element.produto.descricao}} </td>
        </ng-container>

        <ng-container matColumnDef="valorPadrao">
          <th mat-header-cell
              *matHeaderCellDef> VALOR </th>
          <td mat-cell
              *matCellDef="let element"> {{element.produto.valorPadrao | currency:'BRL':'symbol':'1.2-2'}} </td>
        </ng-container>

        <ng-container matColumnDef="quantidade">
          <th mat-header-cell
              *matHeaderCellDef> QUANTIDADE </th>
          <td mat-cell
              *matCellDef="let element; let i = index">
            <div fxLayout="row"
                 class="sales-dialog__quantity"
                 fxLayoutAlign="center center"
                 style="width: 100px;">
              <button color="primary"
                      mat-icon-button
                      matTooltipPosition="above"
                      (click)="remove(element)"
                      [matTooltip]="'Remover'">
                <mat-icon>remove</mat-icon>
              </button>
              <input autocomplete="off"
                     class="sales-dialog__quantity-input"
                     matInput
                     ngClass.gt-xs="ml-2"
                     type="number"
                     [formControlName]="i"
                     [value]="element.quantidade"
                     (keydown)="updateValue(element)" />
              <button mat-icon-button
                      [matTooltip]="'Remover'"
                      (click)="add(element)"
                      matTooltipPosition="above"
                      color="primary">
                <mat-icon>add_circle_outline</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row
            *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row
            *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end"
                      fxLayout="row"
                      fxLayout.xs="column"
                      fxLayoutAlign="space-between center"
                      fxLayoutAlign.xs="center center">
    <button class="sales-dialog__cancel"
            mat-dialog-close
            mat-button
            fxFlexOrder.xs="1"
            ngClass.xs="w-100">Cancelar</button>
    <div fxLayout.xs="column"
         ngClass.xs="w-100"
         fxFlexOrder.xs="0">
      <button color="primary"
              mat-stroked-button
              ngClass.xs="w-100 mb-3"
              type="submit"
              [mat-dialog-close]="false"
              (click)="clearCart()">
        <mat-icon>add_shopping_cart</mat-icon>
        LIMPAR CARRINHO
      </button>
      <button color="primary"
              mat-raised-button
              ngClass.xs="w-100 mb-3"
              type="submit"
              (click)="checkout()"
              [mat-dialog-close]="true">
        <mat-icon>add_shopping_cart</mat-icon>
        FINALIZAR VENDA
      </button>
    </div>
  </mat-dialog-actions>

</section>

<ng-template #noMailPhone>
  <section class="sales-dialog">

    <div mat-dialog-title>
      <h1 fxFlexAlign="start">Informações do Candidato</h1>
      <div class="box"
           fxLayout="column"
           fxLayoutAlign="start start">
        <span>Candidato</span>
        <span>{{matricula.candidato.nome}}</span>
      </div>
    </div>

    <mat-dialog-content fxLayout="column"
                        fxLayoutAlign="start start">
      <span>
        Existem pendências no cadastro do candidato. Clique em REGULARIZAR PENDÊNCIAS para regularizar estas e
        prosseguir com a venda.
      </span>
    </mat-dialog-content>

    <mat-dialog-actions align="end"
                        class="sales-dialog__actions w-100"
                        fxLayout="row"
                        fxLayoutAlign="space-between center">
      <button class="sales-dialog__cancel"
              mat-dialog-close
              mat-button>Cancelar</button>
      <button [mat-dialog-close]="true"
              class="sales-dialog__confirm"
              mat-raised-button
              (click)="regularize()"
              type="submit"
              color="primary">
        <mat-icon>touch_app</mat-icon>
        REGULARIZAR PENDÊNCIAS
      </button>
    </mat-dialog-actions>
  </section>
</ng-template>
